<template>
  <div style="height: 100px">
    <el-row style="text-align: left;margin-top: 10px;">
      <el-col :span="3" style="text-align: right">
        <span>日期：{{ parentData.date }}</span>
      </el-col>
      <el-col :span="3"/>
      <el-col :span="4">
        <span>{{ $t('makeSchedule.mfgProcessReportDetail.cutTotalWeight') }}：{{ parentData.sum_cut_weight.toFixed(2) }}</span>
      </el-col>
      <el-col :span="4">
        <span>切断重量(KG)：{{ parentData.cut_weight.toFixed(2) }}</span>
      </el-col>
      <el-col :span="4">
        <span>{{ $t('makeSchedule.mfgProcessReportDetail.sdCutWeight') }}：{{ parentData.zsp_cut_weight }}</span>
      </el-col>
      <el-col :span="4"/>


      <el-col :span="6"/>
      <el-col :span="4">
          <span>{{ $t('makeSchedule.mfgProcessReportDetail.jgTotalWeight') }}：{{ (parentData.sum_shenei_process_weight + (parentData.shewai_process_weight == null?0:parentData.shewai_process_weight)).toFixed(2)}}</span>
      </el-col>
      <el-col :span="5">
        <span>{{ $t('makeSchedule.mfgProcessReportDetail.snJgTotalWeight') }}：{{ (parentData.sum_shenei_process_weight).toFixed(2) }}</span>
      </el-col>
      <el-col :span="4">
        <span>社内加工重量(KG)：{{ parentData.shenei_process_weight.toFixed(2) }}</span>
      </el-col>
      <el-col :span="4">
        <span>{{ $t('makeSchedule.mfgProcessReportDetail.sdJgTotalWeight') }}：{{ parentData.zsp_process_weight }}</span>
      </el-col>

      <el-col :span="6"/>
      <el-col :span="5">
        <span>社外加工重量(KG)：{{ parentData.shewai_process_weight == null?0:parentData.shewai_process_weight.toFixed(2) }}</span>
      </el-col>
      <el-col :span="4">
        <span>{{ $t('makeSchedule.mfgProcessReportDetail.totalLabor') }}：{{ parentData.total_artificial }}</span>
      </el-col>
      <el-col :span="4">
        <span>生产性：{{ parentData.productive }}</span>
      </el-col>
    </el-row>
    <div style="margin-top: 10px;">
      <FrameTab style="height: 100px" component-param="mfg_process_report_form_tab" :parent-data="parentData"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "MfgProcessReportDetail",
  props: {
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data(){
    return {

    }
  },methods: {

  },created() {

  }
}
</script>

<style scoped>

</style>